// Popup.js
import React from 'react';
import '../../styles/Popup.css';
import { GetGame, IsValid, FetchAccountInfo, GetAuthStatus } from "../../Utilities";
import { useEffect, useState } from "react";
//import { Thumbnail } from 'react-native-thumbnail-video';

export const MediaType = {
    PHOTO: '0',
    YOUTUBEVID: '1',
}

//<div className="popup-filter" />

const Popup = ({ handleClick, gameData, tagData,  developerInfo}) => {
    const REACT_APP_S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;

    var { Name, Description, BackgroundUrl, SteamLink, EpicLink, MediaEntries } = gameData;
    var { DevName } = developerInfo;
    const [selectedMedia, setSelectedMedia ] = useState(0);
    var MediaTable = JSON.parse(MediaEntries);
    const [accountInfo, setAccountInfo] = useState(null);
    const [subscriptionInfo, setSubscriptionInfo] = useState(null);
    const [mediaBigScreenURL, setMediaBigScreenURL] = useState("");
    const [authStatus, setAuthStatus] = useState();

    useEffect(() => {
        if (MediaTable[selectedMedia].type.toString() === MediaType.PHOTO) {
            if (MediaTable[selectedMedia].URL.substr(0, 4) !== "http") {
                setMediaBigScreenURL(process.env.REACT_APP_S3_BASE_URL + MediaTable[selectedMedia].URL);
            }
            else {
                setMediaBigScreenURL(MediaTable[selectedMedia].URL);
            }
        }
    }, [selectedMedia]);

    useEffect(() => {
        setAuthStatus(GetAuthStatus());
    });

    useEffect(() => {
        if (authStatus === true) {
            FetchAccountInfo(setAccountInfo);
        }
    }, [authStatus]);

    useEffect(() => {
        if (IsValid(accountInfo) === true) {
            var subURL = process.env.REACT_APP_NODE_ADDRESS + "/GetSubscription";
            const subReqOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'customer': accountInfo.StripeId })
            };

            fetch(subURL, subReqOptions)
                .then((res) => res.json())
                .then((data) => {
                    //console.log(data);
                    if (data.success === true) {
                        //console.log(data.message);
                        setSubscriptionInfo(data.message);
                        console.log(data.message);
                    }
                    else {
                        setSubscriptionInfo(false);
                    }
                });
        }
    }, [accountInfo])

    //const fullPhotoUrl = `${REACT_APP_S3_BASE_URL}${BackgroundUrl}`
    //<img src={fullPhotoUrl} alt="Game cover" />
    return (
        <div className="popup-screen-cover">
            <div className="popup-card">
                <div className="gameInfoTopRow">

                    <div className="gameTitleInformation">
                        <div className="popup-card-title">
                            <text>{Name}</text>
                        </div>
                        <div className='popup-card-dev-info'>
                            <div className='popup-card-studio-div'>
                                <p className="popup-card-studio">Studio:</p>
                                <p className="popup-card-studio-name">{gameData.DeveloperNameOverride || DevName}</p>
                            </div>
                            {gameData.PublisherName !== undefined && gameData.PublisherName !== "" && gameData.PublisherName !== null && <div className='popup-card-publisher-div'>
                                <p className="popup-card-publisher">Publisher:</p>
                                <p className="popup-card-publisher-name">{gameData.PublisherName}</p>
                            </div>}
                        </div>
                        <div>
                            {IsValid(tagData) === true && tagData.map((tag, index) => (
                                <span className="popup-tag">{tag}</span>
                            ))}
                        </div>
                    </div>

                    <div className="gameMediaSection">
                        <div className="gameMediaBigScreen">
                            {
                                MediaTable[selectedMedia].type.toString() === MediaType.PHOTO && <img src={mediaBigScreenURL}/>
                            }
                            {
                                MediaTable[selectedMedia].type.toString() === MediaType.YOUTUBEVID && <iframe src={MediaTable[selectedMedia].URL} />
                            }
                        </div>
                        <hr/>
                        <div className="gameMediaSelector">
                            {
                                MediaTable.map((entry, index) => {
                                    return <MediaSelectorItem EntryInfo={entry} Index={index} UpdateSelected={setSelectedMedia} Selected={ selectedMedia === index } />;
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="popup-text">

                    <div className='popup-text-content'>
                        <p className="popup-card-description">{Description}</p>
                    </div>
                    {(SteamLink || EpicLink) && <div className="popup-platform-logos">
                        <p className="gameCardLinksTitle">Links</p>
                        {SteamLink && (
                            <a href={SteamLink} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={'/steamIcon.png'}
                                    alt="Steam"
                                    className="platform-logo"
                                    style={{ width: 30, height: 30 }}
                                />
                            </a>
                        )}
                        {EpicLink && (
                            <a href={EpicLink} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={`epicIcon.png`}
                                    alt="Epic"
                                    className="platform-logo"
                                    style={{ width: 30, height: 35 }}
                                />
                            </a>
                        )}
                    </div>}
                </div>

                {((IsValid(accountInfo) === true && IsValid(subscriptionInfo) === true && subscriptionInfo !== false) || gameData.Freeplay === 1) && <div className="gamePopupDownloadEntries">
                    <p className="gamePopupDownloadTitle">Downloads</p>
                    {JSON.parse(gameData.PublicBuildLinks).map((link, index) => {
                        return <div className="downloadLinkListing">
                            <a className="gameDownloadLink" href={process.env.REACT_APP_S3_BASE_URL + link} download>{link.split('/').pop()}</a>
                            {link === gameData.WindowsBuild && <img className="gameDownloadPlatformImg" src="/windows.png" />}
                            {link === gameData.LinuxBuild && <img className="gameDownloadPlatformImg" src="/linux-logo.png" />}
                            {link === gameData.MacBuild && <img className="gameDownloadPlatformImg" src="/mac-os-logo.png" />}
                        </div>
                    })}
                </div>}

                <div className="close-btn" onClick={handleClick}><img src={`${process.env.PUBLIC_URL}/xbutton.svg`} /></div>
                
            </div>
        </div >
    );
};

/*
    
*/

const MediaSelectorItem = (({ EntryInfo, Index, UpdateSelected, Selected }) => {
    const [thumbnailURL, setThumbnailURL] = useState("");

    function ImgClicked() {
        UpdateSelected(Index);
    };

    useEffect(() => {
        console.log(EntryInfo.type.toString() === MediaType.PHOTO);

        if (EntryInfo.type.toString() === MediaType.YOUTUBEVID) {
            var vidId = EntryInfo.URL;
            vidId = vidId.split("/");
            console.log(vidId);
            vidId = vidId[vidId.length-1].split("?")[0];
            setThumbnailURL("https://img.youtube.com/vi/" + vidId + "/hqdefault.jpg");
        }

        if (EntryInfo.type.toString() === MediaType.PHOTO) {
            if (EntryInfo.URL.substr(0, 4) !== "http") {
                setThumbnailURL(process.env.REACT_APP_S3_BASE_URL + EntryInfo.URL);
            }
            else {
                setThumbnailURL(EntryInfo.URL);
            }
        }
    }, [EntryInfo.URL, EntryInfo.type]);
   
    return (
        <div className="gameMediaEntryDiv">
            {EntryInfo.type.toString() === MediaType.PHOTO && <img className={"gameMediaSelectorEntry " + (Selected ? "gameMediaSelected" : "")} src={thumbnailURL} onClick={ImgClicked} /> }
            {EntryInfo.type.toString() === MediaType.YOUTUBEVID && <img className={"gameMediaSelectorEntry " + (Selected ? "gameMediaSelected" : "")} src={thumbnailURL} onClick={ImgClicked} />}
        </div>
    );
});

export default Popup;